// extracted by mini-css-extract-plugin
module.exports = {"box":"communityRulesReview_box__3kd4h","videoContainer":"communityRulesReview_videoContainer__2_l0u"};